// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-preview {
    height: 84vh;
    margin-top: 0;
}

.field-options > *,
.layout-options > * {
    border: 1px solid var(--light);
    padding: 0.2rem 0.4rem;
    border-radius: 0.2rem;
    display: flex;
    align-items: center;
    margin-bottom: 0.4rem;
}

.field-options > *:hover,
.layout-options > *:hover {
    border-color: var(--accent-1);
    transition: 0.2s;
    cursor: move;
}

.email-preview {
    border: 1px solid var(--light);
    border-radius: 0.1rem;
    padding: 2rem;
    min-height: 45vh;
}

.btn-big:hover {
    transition: 0.2s;
    background: var(--accent-2);
    color: var(--text);
}
/* Pdf viewer css for course with pdf document*/
#PdfViewer .box-header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

#PdfViewer .item {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: auto;
    width: 30%; /* A fixed width as the default */
}

#PdfViewer .box-controls {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-grow: 1; /* Set the middle element to grow and stretch */
}

#PdfViewer .box-controls-footer {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-grow: 1; /* Set the middle element to grow and stretch */
}

#PdfViewer .item + #PdfViewer .item {
    margin-left: 2%;
}

#PdfViewer .section-content {
    min-height: 800px
}

#PdfViewer .box-scrollable {
    position: relative;
    width: 100%;
    max-height: 100vh;
    overflow: auto;
    background-color: #F8F9F9;
    box-sizing: border-box;
}

#PdfViewer .footer {
    position: absolute;
    bottom: 1px;
    width: 100%;
    display: block;
    background: #ffffff;
    min-height: 50px;
}

#PdfViewer .canvasWrapper {
    position: relative;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 150px;
}

.mb-50 {
    margin-bottom: 50px;
}

.category-add-input::placeholder {
    color: #999;
}

.dropdown:hover .dropdown-list,
.dropdown.open .dropdown-list {
    max-height: 320px;
    overflow-y: auto;
}

.custom-category-panel {
    background: rgba(59, 130, 246, 0.05);
    outline: 2px solid rgba(59, 130, 246, 0.18);
    outline-offset: -2px;
    border-radius: 6px;
}
.custom-category-panel input:focus{
    border: 1px solid var(--accent-2) !important;
}
.custom-category-panel input{
    width: 50% !important;
    background:white;
}

`, "",{"version":3,"sources":["webpack://./src/styles/admin-styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;;IAEI,8BAA8B;IAC9B,sBAAsB;IACtB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;IAEI,6BAA6B;IAC7B,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;IACrB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;AACtB;AACA,+CAA+C;AAC/C;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,UAAU,EAAE,iCAAiC;AACjD;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY,EAAE,+CAA+C;AACjE;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY,EAAE,+CAA+C;AACjE;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,2CAA2C;IAC3C,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,4CAA4C;AAChD;AACA;IACI,qBAAqB;IACrB,gBAAgB;AACpB","sourcesContent":[".form-preview {\n    height: 84vh;\n    margin-top: 0;\n}\n\n.field-options > *,\n.layout-options > * {\n    border: 1px solid var(--light);\n    padding: 0.2rem 0.4rem;\n    border-radius: 0.2rem;\n    display: flex;\n    align-items: center;\n    margin-bottom: 0.4rem;\n}\n\n.field-options > *:hover,\n.layout-options > *:hover {\n    border-color: var(--accent-1);\n    transition: 0.2s;\n    cursor: move;\n}\n\n.email-preview {\n    border: 1px solid var(--light);\n    border-radius: 0.1rem;\n    padding: 2rem;\n    min-height: 45vh;\n}\n\n.btn-big:hover {\n    transition: 0.2s;\n    background: var(--accent-2);\n    color: var(--text);\n}\n/* Pdf viewer css for course with pdf document*/\n#PdfViewer .box-header {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n#PdfViewer .item {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    height: auto;\n    width: 30%; /* A fixed width as the default */\n}\n\n#PdfViewer .box-controls {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    flex-grow: 1; /* Set the middle element to grow and stretch */\n}\n\n#PdfViewer .box-controls-footer {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    flex-grow: 1; /* Set the middle element to grow and stretch */\n}\n\n#PdfViewer .item + #PdfViewer .item {\n    margin-left: 2%;\n}\n\n#PdfViewer .section-content {\n    min-height: 800px\n}\n\n#PdfViewer .box-scrollable {\n    position: relative;\n    width: 100%;\n    max-height: 100vh;\n    overflow: auto;\n    background-color: #F8F9F9;\n    box-sizing: border-box;\n}\n\n#PdfViewer .footer {\n    position: absolute;\n    bottom: 1px;\n    width: 100%;\n    display: block;\n    background: #ffffff;\n    min-height: 50px;\n}\n\n#PdfViewer .canvasWrapper {\n    position: relative;\n    box-sizing: border-box;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    margin-bottom: 150px;\n}\n\n.mb-50 {\n    margin-bottom: 50px;\n}\n\n.category-add-input::placeholder {\n    color: #999;\n}\n\n.dropdown:hover .dropdown-list,\n.dropdown.open .dropdown-list {\n    max-height: 320px;\n    overflow-y: auto;\n}\n\n.custom-category-panel {\n    background: rgba(59, 130, 246, 0.05);\n    outline: 2px solid rgba(59, 130, 246, 0.18);\n    outline-offset: -2px;\n    border-radius: 6px;\n}\n.custom-category-panel input:focus{\n    border: 1px solid var(--accent-2) !important;\n}\n.custom-category-panel input{\n    width: 50% !important;\n    background:white;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
